// ID-12905 spike — throwaway, delete after verification.
// Route module for the shared-owned sub-page, following client-account-portal's *.route.ts
// convention: the page's path segment lives here and nowhere else. Shared doesn't know where the
// host mounted it, so getPath takes that basePath. Host apps use the same module to build nav
// items and deep-links, so the id travels with the path.

export const id = 'spikeSubPage';

export function getPath({ basePath }: { basePath: string }) {
  return `${basePath}/page-in-shared`;
}
